export enum SceneStatus {
  Ongoing,
  UnStart,
  Ended,
  Invalid,
}
